import { Box, Divider as ChakraDivider } from '@chakra-ui/react';

export function Divider() {
  return (
    <Box width="100%" py={2}>
      <ChakraDivider opacity="0.25" />
    </Box>
  );
}
